<template>
  <div class="main-conent main-conent-maxheight page-survey">
    <el-tabs tab-position="left">
      <el-tab-pane
        v-for="type in types"
        :key="type.id"
        :label="type.title"
        :lazy="true"
      >
        <survey-area v-if="type.name === 'survey_area'"></survey-area>
        <survey-generation
          v-else-if="type.name === 'survey_generation'"
        ></survey-generation>
        <survey-month v-if="type.name === 'survey_month'"></survey-month>
        <survey-liuhe v-if="type.name === 'survey_liuhe_area'"></survey-liuhe>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
const SurveyArea = () => import('./area')
const SurveyGeneration = () => import('./generation')
const SurveyMonth = () => import('./month')
const SurveyLiuhe = () => import('./liuhe')
import { getTypes } from '@/service/survey'

export default {
  components: { SurveyArea, SurveyGeneration, SurveyMonth, SurveyLiuhe },
  data() {
    return {
      loading: false,
      types: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      const { data } = await getTypes(this.companyId)
      this.types = data.reverse()
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
.page-survey {
  .el-tabs,
  .el-tabs__content,
  .el-tab-pane {
    height: 100%;
  }
  .survey-content {
    height: 100%;
  }
}
</style>
